import {
  type SystemOverviewAssetsTable,
  SystemOverviewAssetsTableDocument,
  SystemOverviewRiskSummaryDocument,
} from "$/__generated__/graphql";
import { OverviewDataTables } from "components/tables";
import {
  KEY_CONSEQUENCE_FACTORS_BASE_DEFS,
  KEY_CONSEQUENCE_FACTORS_ROUNDING,
} from "constants/column-defs";
import { useGlobalFiltersContext } from "contexts/filters/global-filters";
import {
  useDataTable,
  useDataTableSummaries,
  useSummariesFormatters,
} from "hooks/queries";
import { useAppliedColumns } from "hooks/useAppliedColumns";

export const SystemOverviewKCF = () => {
  const { hierarchyIdsOverview } = useGlobalFiltersContext();

  const {
    showFoot,
    systemMetric,
    selectionMetric,
    setSelectionMetric,
    setSystemMetric,
    setShowFoot,
    rows,
    loading,
    fetchMoreDataTable,
    isFetchingMore,
  } = useDataTable<SystemOverviewAssetsTable>(
    "systemOverviewAssetsTable",
    SystemOverviewAssetsTableDocument,
    {
      variables: {
        hierarchyIds: hierarchyIdsOverview,
      },
    },
  );

  const appliedColumns = useAppliedColumns<SystemOverviewAssetsTable>(
    "KeyConsequenceFactors",
    KEY_CONSEQUENCE_FACTORS_BASE_DEFS,
  );

  const { columns } = useDataTableSummaries(
    appliedColumns,
    SystemOverviewRiskSummaryDocument,
    {
      variables: {
        hierarchyIds: hierarchyIdsOverview,
        selectionMetricType: selectionMetric,
        systemMetricType: systemMetric,
      },
    },
    useSummariesFormatters(
      selectionMetric,
      systemMetric,
      KEY_CONSEQUENCE_FACTORS_ROUNDING,
    ),
  );

  return (
    <OverviewDataTables
      loading={loading}
      data={rows}
      columns={columns}
      selectionValue={selectionMetric}
      systemValue={systemMetric}
      showFoot={showFoot}
      onSelectionChange={setSelectionMetric}
      onSystemChange={setSystemMetric}
      setShowFoot={setShowFoot}
      onFetchMore={fetchMoreDataTable}
      isFetchingMore={isFetchingMore}
    />
  );
};

export default SystemOverviewKCF;
